<script setup>
import { computed, onMounted, onUnmounted } from "vue"
import { useWindowRegistry } from "../composables/useWindowRegistry"
import ContentWindow from "./ContentWindow.vue"

const props = defineProps({
  labels: { type: Object, default: () => ({}) },
})

const {
  windows,
  openWindow,
  closeWindow,
  minimizeWindow,
  restoreWindow,
  toggleMaximizeWindow,
  focusWindow,
  updateGeometry,
} = useWindowRegistry()

const visibleWindows = computed(() => windows.value.filter((entry) => !entry.minimized))
const minimizedWindows = computed(() => windows.value.filter((entry) => entry.minimized))

function onOpenEvent(event) {
  const { id, title, url } = event.detail || {}
  if (!id) return
  openWindow({ id, title, url })
}

onMounted(() => {
  document.addEventListener("content-window:open", onOpenEvent)
})

onUnmounted(() => {
  document.removeEventListener("content-window:open", onOpenEvent)
})
</script>

<template>
  <Teleport to="body">
    <div class="window-manager" aria-live="polite">
    <ContentWindow
      v-for="entry in visibleWindows"
      :key="entry.id"
      :window-state="entry"
      :labels="labels"
      @close="closeWindow(entry.id)"
      @minimize="minimizeWindow(entry.id)"
      @toggle-maximize="toggleMaximizeWindow(entry.id)"
      @focus="focusWindow(entry.id)"
      @update-geometry="updateGeometry(entry.id, $event)"
    />

    <div v-if="minimizedWindows.length" class="content-window-taskbar">
      <button
        v-for="entry in minimizedWindows"
        :key="`taskbar-${entry.id}`"
        type="button"
        class="content-window-taskbar-btn"
        @click="restoreWindow(entry.id)"
      >
        {{ entry.title }}
      </button>
    </div>
    </div>
  </Teleport>
</template>
